import React, { Component } from 'react';

class Alerta extends Component {

    constructor(props) {
        super(props);
        this.state = {isActive: props.isActive};
    }

    componentWillMount() {
    }

    componentDidUpdate(){
    }

    render() {

        const allGood = <div className="alerta-content">
                            <div className="alerta-content-title">Muchas gracias por tu tiempo.</div>
                            <div className="alerta-content-text">Nuestra mayor satisfacción es que seas parte de <span>Sportium</span>, por ello tenemos excelentes beneficios a tus buenos comentarios recuerda que si nos refieres o agregas a alguien tenemos un regalo para ti, estamos para servirte</div>
                            <div className="alerta-content-subtitle">También nos puedes encontrar en <a href="https://www.facebook.com/SportiumClub/" target="_blank" rel="noopener noreferrer">facebook.com/sportiumclub</a></div>
                        </div>;

        const regular = <div className="alerta-content">
                            <div className="alerta-content-title">Agradecemos tus respuestas, nuestra pasión es atenderte.</div>
                            <div className="alerta-content-text">si tienes alguna duda o sugerencia contactar atención a clientes al 
                                teléfono al <span>1000 2500</span> o al correo <a href="mailto:atencion@sportium.com.mx?Subject=Contacto" target="_top">atencion@sportium.com.mx</a> queremos escucharte.</div>
                        </div>;

        const bad = <div className="alerta-content">
                        <div className="alerta-content-title">Muchas gracias por tus aportaciones, las tomaremos en cuenta.</div>
                        <div className="alerta-content-text">Pronto te contactaremos en los números que proporcionaste en este formato o si lo deseas, 
                        puedes contactar  atención a clientes al teléfono al <span>1000 2500</span> o al correo <a href="mailto:atencion@sportium.com.mx?Subject=Contacto" target="_top">atencion@sportium.com.mx</a> para atenderte lo más pronto posible.</div>
                    </div>;


        return (
            <div className="alerta-overlay">
                <div className="alerta-container">
                    <div className="alerta-wrapper">
                        {(this.props.option === 1) || (this.props.option) === 2 ? bad : ((this.props.option === 3) || (this.props.option === 4) ? regular : allGood)}
                        <i className="close-icon" onClick={this.props.alertEvent}></i>
                    </div>
                </div> 
            </div>
        );
    }
}

export default Alerta;


// WEBPACK FOOTER //
// ./src/components/Alerta.js